import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
import { ErrorBoundaryModal } from '../errorBoundaryModal/errorBoundaryModal';
import { ErrorBoundarySnackbar } from '../errorBoundarySnackbar/errorBoundarySnackbar';
export const ErrorBoundaryPortal = ({ portalId, errors, }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(prev => !prev);
    };
    return createPortal(_jsxs(_Fragment, { children: [_jsx(ErrorBoundarySnackbar, { errorCount: errors.length, onClick: handleOpen }), _jsx(ErrorBoundaryModal, { errors: errors, open: open, onClose: handleOpen })] }), portalId ? document.getElementById(portalId) || document.body : document.body);
};
//# sourceMappingURL=errorBoundaryPortal.js.map